import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Search" }


import InnInput from "@/components/ds/input/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Search',
  props: /*#__PURE__*/_mergeModels({
    placeholder: {
        type: String,
        default: "",
    },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {



const v = _useModel(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InnInput, {
      modelValue: v.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((v).value = $event)),
      placeholder: __props.placeholder
    }, null, 8, ["modelValue", "placeholder"])
  ]))
}
}

})